import * as React from 'react'

import { Box, BoxList, Skeleton } from '@factorialco/deprecated-design-system'

const Illustration = () => {
  return (
    <Box
      style={{
        marginBottom: '16px',
      }}
    >
      <Skeleton width="s32" height="s32" />
    </Box>
  )
}

const Title = () => {
  return (
    <Box maxWidth="s300">
      <Skeleton width="full" height="s24" />
    </Box>
  )
}

const Description = () => {
  return (
    <Box
      style={{
        marginTop: '10px',
      }}
      maxWidth="full"
      gap="s4"
    >
      <Skeleton width="full" height="s16" />
      <Skeleton width="full" height="s16" />
    </Box>
  )
}

const PanesHeader = () => {
  return (
    <Box
      style={{
        marginBottom: '40px',
      }}
    >
      <Illustration />
      <Title />
      <Description />
    </Box>
  )
}

interface BodyItemProps {
  isLast?: boolean
}

const BodyItem = ({ isLast }: BodyItemProps) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      padding="s24"
      gap="s24"
      border={
        isLast
          ? undefined
          : {
              bottom: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }
      }
    >
      <Skeleton width="s40" height="s40" />
      <Box gap="s12">
        <Skeleton width="s80" height="s24" />
        <Skeleton width="s120" height="s16" />
      </Box>
    </Box>
  )
}

const PanesBody = () => {
  return (
    <BoxList>
      <BodyItem />
      <BodyItem />
      <BodyItem />
      <BodyItem isLast />
    </BoxList>
  )
}

const Section = () => {
  return (
    <Box paddingY="s32" paddingX="s64">
      <PanesHeader />
      <PanesBody />
    </Box>
  )
}

const SkeletonLoader = () => {
  return (
    <>
      <Section />
      <Section />
    </>
  )
}

export default SkeletonLoader
